import React from 'react';
// import { useMediaQuery } from 'react-responsive';
import { useMedia } from 'react-use';

const useRWD = () => {
  // @media (min-width: 1024) { ... }
  const isLg = useMedia('(min-width: 1024px)', false);
  // const isLg = useMediaQuery({ minWidth: 1024 })
  return {
    isLg,
  };
};

export default useRWD;
